import React from "react";

export default function Container({ styles, children }) {

    return (
        <div className={`max-w-[1180px] w-full mx-auto container ${styles}`}>
            {children}
        </div>
    )
}